import { render, staticRenderFns } from "./side-panel.vue?vue&type=template&id=af577e56&scoped=true&"
import script from "./side-panel.vue?vue&type=script&lang=js&"
export * from "./side-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af577e56",
  null
  
)

export default component.exports